<div>
    <ul class="flex space-x-2 rtl:space-x-reverse">
        <li>
            <a href="javascript:;" class="text-primary hover:underline">Users</a>
        </li>
        <li class="before:content-['/'] ltr:before:mr-2 rtl:before:ml-2">
            <span>Account Settings</span>
        </li>
    </ul>
    <div class="pt-5">
        <div class="mb-5 flex items-center justify-between">
            <h5 class="text-lg font-semibold dark:text-white-light">Settings</h5>
        </div>
        <div class="mb-5 flex overflow-y-auto whitespace-nowrap border-b border-[#ebedf2] font-semibold dark:border-[#191e3a]">
            <a
                href="javascript:;"
                class="flex gap-2 border-b border-transparent p-4 !outline-none hover:border-primary hover:text-primary"
                [ngClass]="{ '!border-primary text-primary':  activeTab.toLowerCase() === 'home'}"
                (click)="activeTab = 'home'"
            >
                <icon-home />
                Home
            </a>
            <!-- <a
                href="javascript:;"
                class="flex gap-2 border-b border-transparent p-4 !outline-none hover:border-primary hover:text-primary"
                [ngClass]="{ '!border-primary text-primary':  activeTab.toLowerCase() === 'payment-detail'}"
                (click)="activeTab = 'payment-detail'"
            >
                <icon-dollar-sign-circle />
                Payment Details
            </a>
            <a
                href="javascript:;"
                class="flex gap-2 border-b border-transparent p-4 !outline-none hover:border-primary hover:text-primary"
                [ngClass]="{ '!border-primary text-primary':  activeTab.toLowerCase() === 'preferences'}"
                (click)="activeTab = 'preferences'"
            >
                <icon-user class="h-5 w-5" />
                Preferences
            </a>
            <a
                href="javascript:;"
                class="flex gap-2 border-b border-transparent p-4 !outline-none hover:border-primary hover:text-primary"
                [ngClass]="{ '!border-primary text-primary':  activeTab.toLowerCase() === 'danger-zone'}"
                (click)="activeTab = 'danger-zone'"
            >
                <icon-phone />
                Danger Zone
            </a> -->
        </div>
        <div>
            <div *ngIf="activeTab.toLowerCase() === 'home'">
                <form class="mb-5 rounded-md border border-[#ebedf2] bg-white p-4 dark:border-[#191e3a] dark:bg-[#0e1726]">
                    <h6 class="mb-5 text-lg font-bold">General Information</h6>
                    <div class="flex flex-col sm:flex-row">
                        <div class="mb-5 w-full sm:w-2/12 ltr:sm:mr-4 rtl:sm:ml-4">
                            <img src="/assets//images/profile-34.jpeg" alt="" class="mx-auto h-20 w-20 rounded-full object-cover md:h-32 md:w-32" />
                        </div>
                        <div class="grid flex-1 grid-cols-1 gap-5 sm:grid-cols-2">
                            <div>
                                <label for="name">Full Name</label>
                                <input id="name" type="text" placeholder="Jimmy Turner" class="form-input" />
                            </div>
                            <div>
                                <label for="profession">Profession</label>
                                <input id="profession" type="text" placeholder="Web Developer" class="form-input" />
                            </div>
                            <div>
                                <label for="country">Country</label>
                                <select id="country" class="form-select text-white-dark">
                                    <option>All Countries</option>
                                    <option selected>United States</option>
                                    <option>India</option>
                                    <option>Japan</option>
                                    <option>China</option>
                                    <option>Brazil</option>
                                    <option>Norway</option>
                                    <option>Canada</option>
                                </select>
                            </div>
                            <div>
                                <label for="address">Address</label>
                                <input id="address" type="text" placeholder="New York" class="form-input" />
                            </div>
                            <div>
                                <label for="location">Location</label>
                                <input id="location" type="text" placeholder="Location" class="form-input" />
                            </div>
                            <div>
                                <label for="phone">Phone</label>
                                <input id="phone" type="text" placeholder="+1 (530) 555-12121" class="form-input" />
                            </div>
                            <div>
                                <label for="email">Email</label>
                                <input id="email" type="email" placeholder="Jimmy@gmail.com" class="form-input" />
                            </div>
                            <div>
                                <label for="web">Website</label>
                                <input id="web" type="text" placeholder="Enter URL" class="form-input" />
                            </div>
                            <div>
                                <label class="inline-flex cursor-pointer">
                                    <input type="checkbox" class="form-checkbox" />
                                    <span class="relative text-white-dark checked:bg-none">Make this my default address</span>
                                </label>
                            </div>
                            <div class="mt-3 sm:col-span-2">
                                <button type="button" class="btn btn-primary">Save</button>
                            </div>
                        </div>
                    </div>
                </form>
                <form class="rounded-md border border-[#ebedf2] bg-white p-4 dark:border-[#191e3a] dark:bg-[#0e1726]">
                    <h6 class="mb-5 text-lg font-bold">Social</h6>
                    <div class="grid grid-cols-1 gap-5 sm:grid-cols-2">
                        <div class="flex">
                            <div class="flex items-center justify-center rounded bg-[#eee] px-3 font-semibold dark:bg-[#1b2e4b] ltr:mr-2 rtl:ml-2">
                                <icon-linkedin class="h-5 w-5" />
                            </div>
                            <input type="text" placeholder="jimmy_turner" class="form-input" />
                        </div>
                        <div class="flex">
                            <div class="flex items-center justify-center rounded bg-[#eee] px-3 font-semibold dark:bg-[#1b2e4b] ltr:mr-2 rtl:ml-2">
                                <icon-twitter class="h-5 w-5" />
                            </div>
                            <input type="text" placeholder="jimmy_turner" class="form-input" />
                        </div>
                        <div class="flex">
                            <div class="flex items-center justify-center rounded bg-[#eee] px-3 font-semibold dark:bg-[#1b2e4b] ltr:mr-2 rtl:ml-2">
                                <icon-facebook class="h-5 w-5" />
                            </div>
                            <input type="text" placeholder="jimmy_turner" class="form-input" />
                        </div>
                        <div class="flex">
                            <div class="flex items-center justify-center rounded bg-[#eee] px-3 font-semibold dark:bg-[#1b2e4b] ltr:mr-2 rtl:ml-2">
                                <icon-github />
                            </div>
                            <input type="text" placeholder="jimmy_turner" class="form-input" />
                        </div>
                    </div>
                </form>
            </div>
            <div *ngIf="activeTab.toLowerCase() === 'payment-detail'">
                <div class="mb-5 grid grid-cols-1 gap-5 lg:grid-cols-2">
                    <div class="panel">
                        <div class="mb-5">
                            <h5 class="mb-4 text-lg font-semibold">Billing Address</h5>
                            <p>
                                Changes to your <span class="text-primary">Billing</span> information will take effect starting with scheduled payment and will
                                be refelected on your next invoice.
                            </p>
                        </div>
                        <div class="mb-5">
                            <div class="border-b border-[#ebedf2] dark:border-[#1b2e4b]">
                                <div class="flex items-start justify-between py-3">
                                    <h6 class="text-[15px] font-bold text-[#515365] dark:text-white-dark">
                                        Address #1
                                        <span class="mt-1 block text-xs font-normal text-white-dark dark:text-white-light"
                                            >2249 Caynor Circle, New Brunswick, New Jersey</span
                                        >
                                    </h6>
                                    <div class="flex items-start justify-between ltr:ml-auto rtl:mr-auto">
                                        <button class="btn btn-dark">Edit</button>
                                    </div>
                                </div>
                            </div>
                            <div class="border-b border-[#ebedf2] dark:border-[#1b2e4b]">
                                <div class="flex items-start justify-between py-3">
                                    <h6 class="text-[15px] font-bold text-[#515365] dark:text-white-dark">
                                        Address #2
                                        <span class="mt-1 block text-xs font-normal text-white-dark dark:text-white-light"
                                            >4262 Leverton Cove Road, Springfield, Massachusetts</span
                                        >
                                    </h6>
                                    <div class="flex items-start justify-between ltr:ml-auto rtl:mr-auto">
                                        <button class="btn btn-dark">Edit</button>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div class="flex items-start justify-between py-3">
                                    <h6 class="text-[15px] font-bold text-[#515365] dark:text-white-dark">
                                        Address #3
                                        <span class="mt-1 block text-xs font-normal text-white-dark dark:text-white-light"
                                            >2692 Berkshire Circle, Knoxville, Tennessee</span
                                        >
                                    </h6>
                                    <div class="flex items-start justify-between ltr:ml-auto rtl:mr-auto">
                                        <button class="btn btn-dark">Edit</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <button class="btn btn-primary">Add Address</button>
                    </div>
                    <div class="panel">
                        <div class="mb-5">
                            <h5 class="mb-4 text-lg font-semibold">Payment History</h5>
                            <p>
                                Changes to your <span class="text-primary">Payment Method</span> information will take effect starting with scheduled payment
                                and will be refelected on your next invoice.
                            </p>
                        </div>
                        <div class="mb-5">
                            <div class="border-b border-[#ebedf2] dark:border-[#1b2e4b]">
                                <div class="flex items-start justify-between py-3">
                                    <div class="flex-none ltr:mr-4 rtl:ml-4">
                                        <img src="/assets/images/card-americanexpress.svg" alt="" />
                                    </div>
                                    <h6 class="text-[15px] font-bold text-[#515365] dark:text-white-dark">
                                        Mastercard
                                        <span class="mt-1 block text-xs font-normal text-white-dark dark:text-white-light">XXXX XXXX XXXX 9704</span>
                                    </h6>
                                    <div class="flex items-start justify-between ltr:ml-auto rtl:mr-auto">
                                        <button class="btn btn-dark">Edit</button>
                                    </div>
                                </div>
                            </div>
                            <div class="border-b border-[#ebedf2] dark:border-[#1b2e4b]">
                                <div class="flex items-start justify-between py-3">
                                    <div class="flex-none ltr:mr-4 rtl:ml-4">
                                        <img src="/assets/images/card-mastercard.svg" alt="" />
                                    </div>
                                    <h6 class="text-[15px] font-bold text-[#515365] dark:text-white-dark">
                                        American Express<span class="mt-1 block text-xs font-normal text-white-dark dark:text-white-light"
                                            >XXXX XXXX XXXX 310</span
                                        >
                                    </h6>
                                    <div class="flex items-start justify-between ltr:ml-auto rtl:mr-auto">
                                        <button class="btn btn-dark">Edit</button>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div class="flex items-start justify-between py-3">
                                    <div class="flex-none ltr:mr-4 rtl:ml-4">
                                        <img src="/assets/images/card-visa.svg" alt="" />
                                    </div>
                                    <h6 class="text-[15px] font-bold text-[#515365] dark:text-white-dark">
                                        Visa<span class="mt-1 block text-xs font-normal text-white-dark dark:text-white-light">XXXX XXXX XXXX 5264</span>
                                    </h6>
                                    <div class="flex items-start justify-between ltr:ml-auto rtl:mr-auto">
                                        <button class="btn btn-dark">Edit</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <button class="btn btn-primary">Add Payment Method</button>
                    </div>
                </div>
                <div class="grid grid-cols-1 gap-5 lg:grid-cols-2">
                    <div class="panel">
                        <div class="mb-5">
                            <h5 class="mb-4 text-lg font-semibold">Add Billing Address</h5>
                            <p>Changes your New <span class="text-primary">Billing</span> Information.</p>
                        </div>
                        <div class="mb-5">
                            <form>
                                <div class="mb-5 grid grid-cols-1 gap-4 sm:grid-cols-2">
                                    <div>
                                        <label for="billingName">Name</label>
                                        <input id="billingName" type="text" placeholder="Enter Name" class="form-input" />
                                    </div>
                                    <div>
                                        <label for="billingEmail">Email</label>
                                        <input id="billingEmail" type="email" placeholder="Enter Email" class="form-input" />
                                    </div>
                                </div>
                                <div class="mb-5">
                                    <label for="billingAddress">Address</label>
                                    <input id="billingAddress" type="text" placeholder="Enter Address" class="form-input" />
                                </div>
                                <div class="mb-5 grid grid-cols-1 gap-4 md:grid-cols-3 lg:grid-cols-4">
                                    <div class="md:col-span-2">
                                        <label for="billingCity">City</label>
                                        <input id="billingCity" type="text" placeholder="Enter City" class="form-input" />
                                    </div>
                                    <div>
                                        <label for="billingState">State</label>
                                        <select id="billingState" class="form-select text-white-dark">
                                            <option>Choose...</option>
                                            <option>...</option>
                                        </select>
                                    </div>
                                    <div>
                                        <label for="billingZip">Zip</label>
                                        <input id="billingZip" type="text" placeholder="Enter Zip" class="form-input" />
                                    </div>
                                </div>
                                <button type="button" class="btn btn-primary">Add</button>
                            </form>
                        </div>
                    </div>
                    <div class="panel">
                        <div class="mb-5">
                            <h5 class="mb-4 text-lg font-semibold">Add Payment Method</h5>
                            <p>Changes your New <span class="text-primary">Payment Method</span> Information.</p>
                        </div>
                        <div class="mb-5">
                            <form>
                                <div class="mb-5 grid grid-cols-1 gap-4 sm:grid-cols-2">
                                    <div>
                                        <label for="payBrand">Card Brand</label>
                                        <select id="payBrand" class="form-select text-white-dark">
                                            <option selected>Mastercard</option>
                                            <option>American Express</option>
                                            <option>Visa</option>
                                            <option>Discover</option>
                                        </select>
                                    </div>
                                    <div>
                                        <label for="payNumber">Card Number</label>
                                        <input id="payNumber" type="text" placeholder="Card Number" class="form-input" />
                                    </div>
                                </div>
                                <div class="mb-5 grid grid-cols-1 gap-4 sm:grid-cols-2">
                                    <div>
                                        <label for="payHolder">Holder Name</label>
                                        <input id="payHolder" type="text" placeholder="Holder Name" class="form-input" />
                                    </div>
                                    <div>
                                        <label for="payCvv">CVV/CVV2</label>
                                        <input id="payCvv" type="text" placeholder="CVV" class="form-input" />
                                    </div>
                                </div>
                                <div class="mb-5 grid grid-cols-1 gap-4 sm:grid-cols-2">
                                    <div>
                                        <label for="payExp">Card Expiry</label>
                                        <input id="payExp" type="text" placeholder="Card Expiry" class="form-input" />
                                    </div>
                                </div>
                                <button type="button" class="btn btn-primary">Add</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="activeTab.toLowerCase() === 'preferences'" class="switch">
                <div class="mb-5 grid grid-cols-1 gap-5 lg:grid-cols-2">
                    <div class="panel space-y-5">
                        <h5 class="mb-4 text-lg font-semibold">Choose Theme</h5>
                        <div class="flex justify-around">
                            <label class="inline-flex cursor-pointer">
                                <input class="form-radio cursor-pointer ltr:mr-4 rtl:ml-4" type="radio" name="flexRadioDefault" checked />
                                <span>
                                    <img class="ms-3" width="100" height="68" alt="settings-dark" src="/assets/images/settings-light.svg" />
                                </span>
                            </label>

                            <label class="inline-flex cursor-pointer">
                                <input class="form-radio cursor-pointer ltr:mr-4 rtl:ml-4" type="radio" name="flexRadioDefault" />
                                <span>
                                    <img class="ms-3" width="100" height="68" alt="settings-light" src="/assets/images/settings-dark.svg" />
                                </span>
                            </label>
                        </div>
                    </div>
                    <div class="panel space-y-5">
                        <h5 class="mb-4 text-lg font-semibold">Activity data</h5>
                        <p>Download your Summary, Task and Payment History Data</p>
                        <button type="button" class="btn btn-primary">Download Data</button>
                    </div>
                </div>
                <div class="grid grid-cols-1 gap-5 md:grid-cols-3">
                    <div class="panel space-y-5">
                        <h5 class="mb-4 text-lg font-semibold">Public Profile</h5>
                        <p>Your <span class="text-primary">Profile</span> will be visible to anyone on the network.</p>
                        <label class="relative h-6 w-12">
                            <input
                                type="checkbox"
                                class="custom_switch peer absolute z-10 h-full w-full cursor-pointer opacity-0"
                                id="custom_switch_checkbox1"
                            />
                            <span
                                for="custom_switch_checkbox1"
                                class="block h-full rounded-full bg-[#ebedf2] before:absolute before:bottom-1 before:left-1 before:h-4 before:w-4 before:rounded-full before:bg-white before:transition-all before:duration-300 peer-checked:bg-primary peer-checked:before:left-7 dark:bg-dark dark:before:bg-white-dark dark:peer-checked:before:bg-white"
                            ></span>
                        </label>
                    </div>
                    <div class="panel space-y-5">
                        <h5 class="mb-4 text-lg font-semibold">Show my email</h5>
                        <p>Your <span class="text-primary">Email</span> will be visible to anyone on the network.</p>
                        <label class="relative h-6 w-12">
                            <input
                                type="checkbox"
                                class="custom_switch peer absolute z-10 h-full w-full cursor-pointer opacity-0"
                                id="custom_switch_checkbox2"
                            />
                            <span
                                for="custom_switch_checkbox2"
                                class="block h-full rounded-full bg-[#ebedf2] before:absolute before:bottom-1 before:left-1 before:h-4 before:w-4 before:rounded-full before:bg-white before:transition-all before:duration-300 peer-checked:bg-primary peer-checked:before:left-7 dark:bg-dark dark:before:bg-white-dark dark:peer-checked:before:bg-white"
                            ></span>
                        </label>
                    </div>
                    <div class="panel space-y-5">
                        <h5 class="mb-4 text-lg font-semibold">Enable keyboard shortcuts</h5>
                        <p>When enabled, press <span class="text-primary">ctrl</span> for help</p>
                        <label class="relative h-6 w-12">
                            <input
                                type="checkbox"
                                class="custom_switch peer absolute z-10 h-full w-full cursor-pointer opacity-0"
                                id="custom_switch_checkbox3"
                            />
                            <span
                                for="custom_switch_checkbox3"
                                class="block h-full rounded-full bg-[#ebedf2] before:absolute before:bottom-1 before:left-1 before:h-4 before:w-4 before:rounded-full before:bg-white before:transition-all before:duration-300 peer-checked:bg-primary peer-checked:before:left-7 dark:bg-dark dark:before:bg-white-dark dark:peer-checked:before:bg-white"
                            ></span>
                        </label>
                    </div>
                    <div class="panel space-y-5">
                        <h5 class="mb-4 text-lg font-semibold">Hide left navigation</h5>
                        <p>Sidebar will be <span class="text-primary">hidden</span> by default</p>
                        <label class="relative h-6 w-12">
                            <input
                                type="checkbox"
                                class="custom_switch peer absolute z-10 h-full w-full cursor-pointer opacity-0"
                                id="custom_switch_checkbox4"
                            />
                            <span
                                for="custom_switch_checkbox4"
                                class="block h-full rounded-full bg-[#ebedf2] before:absolute before:bottom-1 before:left-1 before:h-4 before:w-4 before:rounded-full before:bg-white before:transition-all before:duration-300 peer-checked:bg-primary peer-checked:before:left-7 dark:bg-dark dark:before:bg-white-dark dark:peer-checked:before:bg-white"
                            ></span>
                        </label>
                    </div>
                    <div class="panel space-y-5">
                        <h5 class="mb-4 text-lg font-semibold">Advertisements</h5>
                        <p>Display <span class="text-primary">Ads</span> on your dashboard</p>
                        <label class="relative h-6 w-12">
                            <input
                                type="checkbox"
                                class="custom_switch peer absolute z-10 h-full w-full cursor-pointer opacity-0"
                                id="custom_switch_checkbox5"
                            />
                            <span
                                for="custom_switch_checkbox5"
                                class="block h-full rounded-full bg-[#ebedf2] before:absolute before:bottom-1 before:left-1 before:h-4 before:w-4 before:rounded-full before:bg-white before:transition-all before:duration-300 peer-checked:bg-primary peer-checked:before:left-7 dark:bg-dark dark:before:bg-white-dark dark:peer-checked:before:bg-white"
                            ></span>
                        </label>
                    </div>
                    <div class="panel space-y-5">
                        <h5 class="mb-4 text-lg font-semibold">Social Profile</h5>
                        <p>Enable your <span class="text-primary">social</span> profiles on this network</p>
                        <label class="relative h-6 w-12">
                            <input
                                type="checkbox"
                                class="custom_switch peer absolute z-10 h-full w-full cursor-pointer opacity-0"
                                id="custom_switch_checkbox6"
                            />
                            <span
                                for="custom_switch_checkbox6"
                                class="block h-full rounded-full bg-[#ebedf2] before:absolute before:bottom-1 before:left-1 before:h-4 before:w-4 before:rounded-full before:bg-white before:transition-all before:duration-300 peer-checked:bg-primary peer-checked:before:left-7 dark:bg-dark dark:before:bg-white-dark dark:peer-checked:before:bg-white"
                            ></span>
                        </label>
                    </div>
                </div>
            </div>
            <div *ngIf="activeTab.toLowerCase() === 'danger-zone'" class="switch">
                <div class="grid grid-cols-1 gap-5 md:grid-cols-3">
                    <div class="panel space-y-5">
                        <h5 class="mb-4 text-lg font-semibold">Purge Cache</h5>
                        <p>Remove the active resource from the cache without waiting for the predetermined cache expiry time.</p>
                        <button class="btn btn-secondary">Clear</button>
                    </div>
                    <div class="panel space-y-5">
                        <h5 class="mb-4 text-lg font-semibold">Deactivate Account</h5>
                        <p>You will not be able to receive messages, notifications for up to 24 hours.</p>
                        <label class="relative h-6 w-12">
                            <input
                                type="checkbox"
                                class="custom_switch peer absolute z-10 h-full w-full cursor-pointer opacity-0"
                                id="custom_switch_checkbox7"
                            />
                            <span
                                for="custom_switch_checkbox7"
                                class="block h-full rounded-full bg-[#ebedf2] before:absolute before:bottom-1 before:left-1 before:h-4 before:w-4 before:rounded-full before:bg-white before:transition-all before:duration-300 peer-checked:bg-primary peer-checked:before:left-7 dark:bg-dark dark:before:bg-white-dark dark:peer-checked:before:bg-white"
                            ></span>
                        </label>
                    </div>
                    <div class="panel space-y-5">
                        <h5 class="mb-4 text-lg font-semibold">Delete Account</h5>
                        <p>Once you delete the account, there is no going back. Please be certain.</p>
                        <button class="btn btn-danger btn-delete-account">Delete my account</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
